<nb-card class="fullHeight dialog-card fullWidth" kveDialogBackdrop>
    <!-- <nb-layout windowMode> -->
    <!-- <nb-layout-header> -->
    <nb-card-header>
        <!-- <div class="title">Section : {{rendererType}} | Cell : {{contentEnum}}</div> -->
        <div class="action">
            <nb-actions size="tiny">
                <nb-action title="Renderer">
                    Section : {{rendererType}}
                </nb-action>
                <nb-action title="Content Enum">
                    Active Cell : {{contentEnum}}
                </nb-action>
                <nb-action>
                    <button nbButton size="tiny" [nbContextMenu]="contextMenuItems" nbContextMenuTag="sectionEditorMenu"
                        kveStyleContextMenu>
                        Set Active Cell
                    </button>
                </nb-action>
            </nb-actions>
        </div>
        <div class="screens">
            <nb-actions size="tiny">
                <nb-action title="Mobile" (click)="setScreen('mobile')">
                    <nb-icon class="toggle-icon" icon="smartphone-outline" pack="eva">Mobile</nb-icon>
                </nb-action>
                <nb-action title="Laptop" (click)="setScreen('laptop')">
                    <nb-icon class="toggle-icon" icon="browser-outline" pack="eva">Laptop</nb-icon>
                </nb-action>
                <nb-action title="Desktop" (click)="setScreen('default')">
                    <nb-icon class="toggle-icon" icon="monitor-outline" pack="eva">Desktop</nb-icon>
                </nb-action>
            </nb-actions>
        </div>
        <div class="action">
            <nb-actions size="tiny">
                <nb-action title="Save" (click)="onSameLayout($event)">
                    <nb-checkbox>Apply Layout To All</nb-checkbox>
                </nb-action>
                <nb-action title="Save" (click)="onSameTheme($event)">
                    <nb-checkbox>Apply Colours To All</nb-checkbox>
                </nb-action>
                <nb-action title="Save" (click)="onSave($event)">
                    <nb-icon class="toggle-icon" icon="save-outline" pack="eva">Save</nb-icon>
                </nb-action>
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
    </nb-card-header>
    <!-- </nb-layout-header> -->
    <div class="layout-container">
        <nb-sidebar class="editor-sidebar" state="compacted" tag="editorSideBar">
            <nb-menu [items]="mainMenuItems" tag="sectionEditorMenu" autoCollapse="false" kveMenuItemPopover></nb-menu>
            <!-- <kve-side-bar-menues (secondaryMenu)="populateSecondaryMenu($event)"></kve-side-bar-menues> -->
        </nb-sidebar>
        <!-- <nb-sidebar class="editor-secondary" state="expanded" tag="optionsSideBar" #secondarySideBar>
            <kve-editor-template-options orientation="vertical" [section]="section" [rendererType]="rendererType"></kve-editor-template-options>
          </nb-sidebar> -->
        <!-- <nb-sidebar right class="styling-sidebar" state="compacted" tag="styling" #secondarySideBar>
            <nb-menu [items]="editMenuItems" tag="cellEditorTag"></nb-menu>
        </nb-sidebar> -->
        <nb-sidebar right tag="right">
            <nb-menu [items]="childMenuItems" tag="editorSelector"></nb-menu>
        </nb-sidebar>
        <!-- <nb-layout-column> -->
        <div class="content">
            <div class="columns">
                <div class="preview-editor-container">
                    <ng-container *ngIf="hasLoaded;else loading">
                        <div class="preview" kvePreviewThemeBg>
                            <div class="preview-image">
                                <kve-shared-preview-editor [section]="section" [cellId]="cellId"
                                    [selectedCell]="selectedCell$ | async" [selectedTabTitle]="selectedTabTitle"
                                    [size]="screenSize" (responsiveView)="loadResponsive($event)">
                                </kve-shared-preview-editor>
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #loading>
                        <div class="loading-container">
                            <div>Loading</div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </div>


    </div>

    <!-- <nb-card-footer kveFreeDragging class="draggable-container expanded" #expandableFooter>
        <div>
            <div kveDraggingHandle class="dragging-handle">
                <nb-actions size="tiny" >
                    <nb-action>
                        <button nbButton size="tiny"
                            [nbPopover]="fieldSummaryPop"
                            nbPopoverPlacement="left"
                            [nbPopoverContext]="{title:'Field Summary',cell:selectedCell}"><nb-icon class="icon-button" icon="eye-outline" pack="eva"></nb-icon>View All Fields</button>
                    </nb-action>
                </nb-actions>
                <nb-icon class="expand-collapse" [icon]="expandedFooter?'collapse-outline':'expand-outline'" pack="eva" (click)="toggleFooter()"></nb-icon>
            </div>
            <ng-container [ngSwitch]="rendererType">
                <ng-container *ngSwitchCase="'grid'">
                    <ng-container [ngSwitch]="contentEnum">
                        <ng-container *ngSwitchCase="'Banner'">
                            <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Link'">
                            <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'product'">
                    <ng-container [ngSwitch]="contentEnum">
                        <ng-container *ngSwitchCase="'Gallery'">
                            <div class="editor-header gallery-header">Gallery</div>
                            <div class="editor-content-selectors gallery-editor">
                                <div *ngFor="let contentElement of selectedCell.contentElements" class="image-container" (click)="pickGalleryImage(contentElement)">
                                    <img [src]="contentElement.imgSrc">
                                </div>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Identification'">
                            <kve-identification-editor [contentElements]="selectedCell.contentElements"></kve-identification-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Classification'">
                            <kve-product-classification [contentElements]="selectedCell.contentElements"></kve-product-classification>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Variant'">
                            <kve-variant-editor [contentElements]="selectedCell.contentElements"></kve-variant-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Price'">
                            <kve-price-editor [contentElements]="selectedCell.contentElements"></kve-price-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Short Description'">
                            <div class="editor-header">Product Short Description</div>
                            <div class="editor-content-selectors">
                                <kve-description-editor [contentElements]="selectedCell.contentElements"></kve-description-editor>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Long Description'">
                            <div class="editor-header">Product Long Description</div>
                            <div class="editor-content-selectors">
                                <kve-long-description-editor [contentElements]="selectedCell.contentElements"></kve-long-description-editor>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Rating'">
                            <div class="editor-header">Product Rating</div>
                            <div class="editor-content-selectors">
                                <kve-ratings-editor [contentElements]="selectedCell.contentElements"></kve-ratings-editor>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Share'">
                            <div class="editor-header">Product Share</div>
                            <div class="editor-content-selectors">
                                <kve-product-share-editor [contentElements]="selectedCell.contentElements"></kve-product-share-editor>
                            </div>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Standard Features'">
                            <kve-features-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="standard"></kve-features-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Selectable Features'">
                            <kve-features-editor  [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="selectable"></kve-features-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Add To Cart'">
                            <kve-add-to-cart-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="selectable"></kve-add-to-cart-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Banner'">
                            <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                        </ng-container>
                        <ng-container *ngSwitchCase="'Product Cell'">
                            <kve-row-cell-editor [contentElements]="selectedCell.contentElements"></kve-row-cell-editor>
                        </ng-container>
                        <ng-container *ngSwitchDefault>


                        </ng-container>
                    </ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'banner'">
                    <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                </ng-container>
                <ng-container *ngSwitchCase="'testimonials'">
                    <kve-testimonial-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section"></kve-testimonial-cell-editor>
                </ng-container>
                <ng-container *ngSwitchCase="'slider'">
                    <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                </ng-container>
                <ng-container *ngSwitchCase="'hero-image'">
                    <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                </ng-container>
                <ng-container *ngSwitchCase="'row'">
                    <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                </ng-container>
                <ng-container *ngSwitchCase="'bloglist'">
                    <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <nb-tabset #editorDialogTabs (changeTab)="onChangeTabImages($event)">
                        <nb-tab tabTitle="Content" #contentTab>
                            <kve-cell-text-editor
                            [rendererType]="rendererType"
                            tabbed=true></kve-cell-text-editor>
                        </nb-tab>
                        <nb-tab tabTitle="Background" #bgTab>
                            <kve-cell-bg-editor
                            [section]="section"
                            [cellId]="cellId"
                            [selectedCell]="selectedCell"
                            tabbed=true></kve-cell-bg-editor>
                        </nb-tab>
                        <nb-tab tabTitle="Images" #imageTab disabled>
                            <kve-sample-image-directory
                            [section]="section"
                            tabbed=true
                            ></kve-sample-image-directory>
                        </nb-tab>
                        <nb-tab tabTitle="Layout" #layoutTab disabled>
                            <kve-cell-layout-editor
                            [section]="section"
                            [cellId]="cellId"
                            [cellLayoutThumbs]="cellLayoutThumbs"
                            tabbed=true
                            (selectedLayout)="onLayouSelected($event)"
                            ></kve-cell-layout-editor>
                        </nb-tab>
                        <nb-tab tabTitle="Styles" #colourTab disabled>
                            <kve-cell-theme-editor
                            [section]="section"
                            [cellId]="cellId"
                            tabbed=true
                            >

                            </kve-cell-theme-editor>
                        </nb-tab>

                        <nb-tab tabTitle="Link">
                            <button nbButton size="small" status="primary" (click)="export()">Download</button>
                        </nb-tab>
                    </nb-tabset>
                </ng-container>
            </ng-container>


        </div>
    </nb-card-footer> -->

    <!-- </nb-layout-column> -->
    <!-- <nb-card class="fullHeight dialog-card fullWidth" kveDialogBackdrop> -->
    <!-- <nb-card class="fullHeight dialog-card fullWidth"> -->
    <!-- <nb-card-header>
        <div class="title">{{title}}</div>
        <div class="screens">
            <nb-actions size="tiny">
                <nb-action title="Mobile" (click)="setScreen('mobile')">
                    <nb-icon class="toggle-icon" icon="smartphone-outline" pack="eva">Mobile</nb-icon>
                </nb-action>
                <nb-action title="Laptop" (click)="setScreen('laptop')">
                    <nb-icon class="toggle-icon" icon="browser-outline" pack="eva">Laptop</nb-icon>
                </nb-action>
                <nb-action title="Desktop" (click)="setScreen('default')">
                    <nb-icon class="toggle-icon" icon="monitor-outline" pack="eva">Desktop</nb-icon>
                </nb-action>
            </nb-actions>
        </div>
        <div class="action">
            <nb-actions size="tiny">
                <nb-action title="Save" (click)="onSameLayout($event)">
                    <nb-checkbox>Apply Layout To All</nb-checkbox>
                </nb-action>
                <nb-action title="Save" (click)="onSameTheme($event)">
                    <nb-checkbox>Apply Colours To All</nb-checkbox>
                </nb-action>
                <nb-action title="Save" (click)="onSave($event)">
                    <nb-icon class="toggle-icon" icon="save-outline" pack="eva">Save</nb-icon>
                </nb-action>
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
    </nb-card-header> -->
    <!-- <nb-layout>
        <nb-sidebar class="editor-sidebar" state="compacted" tag="primary">
            <nb-menu [items]="mainMenuItems" tag="editorMainMenu"></nb-menu>
        </nb-sidebar>
        <nb-sidebar right class="styling-sidebar" state="compacted" tag="styling" #secondarySideBar>
            <nb-menu [items]="editMenuItems" tag="editItemsMenu"></nb-menu>

        </nb-sidebar>
        <nb-sidebar right tag="right">
            <nb-menu [items]="sectionCells" tag="elementTag"></nb-menu>
        </nb-sidebar>
        <nb-layout-column>
            <div class="preview-editor-container">
                <div class="preview" kvePreviewThemeBg>
                    <div class="preview-image">
                        <kve-shared-preview-editor
                            [section]="section"
                            [selectedCell]="selectedCell"
                            [cellId]="cellId"
                            [selectedTabTitle]="selectedTabTitle"
                            [size]="screenSize"
                            (responsiveView)="loadResponsive($event)">
                        </kve-shared-preview-editor>
                    </div>
                </div>
                <nb-card-footer kveFreeDragging class="draggable-container expanded" #expandableFooter>
                    <div>
                        <div kveDraggingHandle class="dragging-handle">
                            <nb-actions size="tiny" >
                                <nb-action>
                                    <button nbButton size="tiny"
                                        [nbPopover]="fieldSummaryPop"
                                        nbPopoverPlacement="left"
                                        [nbPopoverContext]="{title:'Field Summary',cell:selectedCell}"><nb-icon class="icon-button" icon="eye-outline" pack="eva"></nb-icon>View All Fields</button>
                                </nb-action>
                            </nb-actions>
                            <nb-icon class="expand-collapse" [icon]="expandedFooter?'collapse-outline':'expand-outline'" pack="eva" (click)="toggleFooter()"></nb-icon>
                        </div>
                        <ng-container [ngSwitch]="rendererType">
                            <ng-container *ngSwitchCase="'grid'">
                                <ng-container [ngSwitch]="contentEnum">
                                    <ng-container *ngSwitchCase="'Banner'">
                                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Link'">
                                        <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'product'">
                                <ng-container [ngSwitch]="contentEnum">
                                    <ng-container *ngSwitchCase="'Gallery'">
                                        <div class="editor-header gallery-header">Gallery</div>
                                        <div class="editor-content-selectors gallery-editor">
                                            <div *ngFor="let contentElement of selectedCell.contentElements" class="image-container" (click)="pickGalleryImage(contentElement)">
                                                <img [src]="contentElement.imgSrc">
                                            </div>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Identification'">
                                        <kve-identification-editor [contentElements]="selectedCell.contentElements"></kve-identification-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Classification'">
                                        <kve-product-classification [contentElements]="selectedCell.contentElements"></kve-product-classification>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Variant'">
                                        <kve-variant-editor [contentElements]="selectedCell.contentElements"></kve-variant-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Price'">
                                        <kve-price-editor [contentElements]="selectedCell.contentElements"></kve-price-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Short Description'">
                                        <div class="editor-header">Product Short Description</div>
                                        <div class="editor-content-selectors">
                                            <kve-description-editor [contentElements]="selectedCell.contentElements"></kve-description-editor>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Long Description'">
                                        <div class="editor-header">Product Long Description</div>
                                        <div class="editor-content-selectors">
                                            <kve-long-description-editor [contentElements]="selectedCell.contentElements"></kve-long-description-editor>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Rating'">
                                        <div class="editor-header">Product Rating</div>
                                        <div class="editor-content-selectors">
                                            <kve-ratings-editor [contentElements]="selectedCell.contentElements"></kve-ratings-editor>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Share'">
                                        <div class="editor-header">Product Share</div>
                                        <div class="editor-content-selectors">
                                            <kve-product-share-editor [contentElements]="selectedCell.contentElements"></kve-product-share-editor>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Standard Features'">
                                        <kve-features-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="standard"></kve-features-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Selectable Features'">
                                        <kve-features-editor  [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="selectable"></kve-features-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Add To Cart'">
                                        <kve-add-to-cart-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="selectable"></kve-add-to-cart-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Banner'">
                                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchCase="'Product Cell'">
                                        <kve-row-cell-editor [contentElements]="selectedCell.contentElements"></kve-row-cell-editor>
                                    </ng-container>
                                    <ng-container *ngSwitchDefault>


                                    </ng-container>
                                </ng-container>
                            </ng-container>
                            <ng-container *ngSwitchCase="'banner'">
                                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'testimonials'">
                                <kve-testimonial-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section"></kve-testimonial-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'slider'">
                                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'hero-image'">
                                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'row'">
                                <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'bloglist'">
                                <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchDefault>
                                <nb-tabset #editorDialogTabs (changeTab)="onChangeTabImages($event)">
                                    <nb-tab tabTitle="Content" #contentTab>
                                        <kve-cell-text-editor
                                        [rendererType]="rendererType"
                                        tabbed=true></kve-cell-text-editor>
                                    </nb-tab>
                                    <nb-tab tabTitle="Background" #bgTab>
                                        <kve-cell-bg-editor
                                        [section]="section"
                                        [cellId]="cellId"
                                        [selectedCell]="selectedCell"
                                        tabbed=true></kve-cell-bg-editor>
                                    </nb-tab>
                                    <nb-tab tabTitle="Images" #imageTab disabled>
                                        <kve-sample-image-directory
                                        [section]="section"
                                        tabbed=true
                                        ></kve-sample-image-directory>
                                    </nb-tab>
                                    <nb-tab tabTitle="Layout" #layoutTab disabled>
                                        <kve-cell-layout-editor
                                        [section]="section"
                                        [cellId]="cellId"
                                        [cellLayoutThumbs]="cellLayoutThumbs"
                                        tabbed=true
                                        (selectedLayout)="onLayouSelected($event)"
                                        ></kve-cell-layout-editor>
                                    </nb-tab>
                                    <nb-tab tabTitle="Styles" #colourTab disabled>
                                        <kve-cell-theme-editor
                                        [section]="section"
                                        [cellId]="cellId"
                                        tabbed=true
                                        >

                                        </kve-cell-theme-editor>
                                    </nb-tab>

                                    <nb-tab tabTitle="Link">
                                        <button nbButton size="small" status="primary" (click)="export()">Download</button>
                                    </nb-tab>
                                </nb-tabset>
                            </ng-container>
                        </ng-container>


                    </div>
                </nb-card-footer>
            </div>
        </nb-layout-column>
    </nb-layout> -->
    <!-- <nb-card-header>
        <div class="title">{{title}}</div>
        <div class="screens">
            <nb-actions size="tiny">
                <nb-action title="Mobile" (click)="setScreen('mobile')">
                    <nb-icon class="toggle-icon" icon="smartphone-outline" pack="eva">Mobile</nb-icon>
                </nb-action>
                <nb-action title="Laptop" (click)="setScreen('laptop')">
                    <nb-icon class="toggle-icon" icon="browser-outline" pack="eva">Laptop</nb-icon>
                </nb-action>
                <nb-action title="Desktop" (click)="setScreen('default')">
                    <nb-icon class="toggle-icon" icon="monitor-outline" pack="eva">Desktop</nb-icon>
                </nb-action>
            </nb-actions>
        </div>
        <div class="action">
            <nb-actions size="tiny">
                <nb-action title="Save" (click)="onSameLayout($event)">
                    <nb-checkbox>Apply Layout To All</nb-checkbox>
                </nb-action>
                <nb-action title="Save" (click)="onSameTheme($event)">
                    <nb-checkbox>Apply Colours To All</nb-checkbox>
                </nb-action>
                <nb-action title="Save" (click)="onSave($event)">
                    <nb-icon class="toggle-icon" icon="save-outline" pack="eva">Save</nb-icon>
                </nb-action>
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
    </nb-card-header> -->
    <!-- <div class="preview-editor-container">
        <div class="preview" kvePreviewThemeBg>
            <div class="preview-image">
                <kve-shared-preview-editor
                    [section]="section"
                    [selectedCell]="selectedCell"
                    [cellId]="cellId"
                    [selectedTabTitle]="selectedTabTitle"
                    [size]="screenSize"
                    (responsiveView)="loadResponsive($event)">
                </kve-shared-preview-editor>
            </div>
        </div>
        <nb-card-footer kveFreeDragging class="draggable-container expanded" #expandableFooter>
            <div>
                <div kveDraggingHandle class="dragging-handle">
                    <nb-actions size="tiny" >
                        <nb-action>
                            <button nbButton size="tiny"
                                [nbPopover]="fieldSummaryPop"
                                nbPopoverPlacement="left"
                                [nbPopoverContext]="{title:'Field Summary',cell:selectedCell}"><nb-icon class="icon-button" icon="eye-outline" pack="eva"></nb-icon>View All Fields</button>
                        </nb-action>
                    </nb-actions>
                    <nb-icon class="expand-collapse" [icon]="expandedFooter?'collapse-outline':'expand-outline'" pack="eva" (click)="toggleFooter()"></nb-icon>
                </div>
                <ng-container [ngSwitch]="rendererType">
                    <ng-container *ngSwitchCase="'grid'">
                        <ng-container [ngSwitch]="contentEnum">
                            <ng-container *ngSwitchCase="'Banner'">
                                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Link'">
                                <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'product'">
                        <ng-container [ngSwitch]="contentEnum">
                            <ng-container *ngSwitchCase="'Gallery'">
                                <div class="editor-header gallery-header">Gallery</div>
                                <div class="editor-content-selectors gallery-editor">
                                    <div *ngFor="let contentElement of selectedCell.contentElements" class="image-container" (click)="pickGalleryImage(contentElement)">
                                        <img [src]="contentElement.imgSrc">
                                    </div>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Identification'">
                                <kve-identification-editor [contentElements]="selectedCell.contentElements"></kve-identification-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Classification'">
                                <kve-product-classification [contentElements]="selectedCell.contentElements"></kve-product-classification>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Variant'">
                                <kve-variant-editor [contentElements]="selectedCell.contentElements"></kve-variant-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Price'">
                                <kve-price-editor [contentElements]="selectedCell.contentElements"></kve-price-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Short Description'">
                                <div class="editor-header">Product Short Description</div>
                                <div class="editor-content-selectors">
                                    <kve-description-editor [contentElements]="selectedCell.contentElements"></kve-description-editor>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Long Description'">
                                <div class="editor-header">Product Long Description</div>
                                <div class="editor-content-selectors">
                                    <kve-long-description-editor [contentElements]="selectedCell.contentElements"></kve-long-description-editor>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Rating'">
                                <div class="editor-header">Product Rating</div>
                                <div class="editor-content-selectors">
                                    <kve-ratings-editor [contentElements]="selectedCell.contentElements"></kve-ratings-editor>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Share'">
                                <div class="editor-header">Product Share</div>
                                <div class="editor-content-selectors">
                                    <kve-product-share-editor [contentElements]="selectedCell.contentElements"></kve-product-share-editor>
                                </div>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Standard Features'">
                                <kve-features-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="standard"></kve-features-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Selectable Features'">
                                <kve-features-editor  [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="selectable"></kve-features-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Add To Cart'">
                                <kve-add-to-cart-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" featureType="selectable"></kve-add-to-cart-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Banner'">
                                <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchCase="'Product Cell'">
                                <kve-row-cell-editor [contentElements]="selectedCell.contentElements"></kve-row-cell-editor>
                            </ng-container>
                            <ng-container *ngSwitchDefault>


                            </ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngSwitchCase="'banner'">
                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'testimonials'">
                        <kve-testimonial-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section"></kve-testimonial-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'slider'">
                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'hero-image'">
                        <kve-banner-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-banner-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'row'">
                        <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchCase="'bloglist'">
                        <kve-row-cell-editor [contentEnum]="contentEnum" [contentElements]="selectedCell.contentElements" [section]="section" [cellId]="cellId"></kve-row-cell-editor>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <nb-tabset #editorDialogTabs (changeTab)="onChangeTabImages($event)">
                            <nb-tab tabTitle="Content" #contentTab>
                                <kve-cell-text-editor
                                [rendererType]="rendererType"
                                tabbed=true></kve-cell-text-editor>
                            </nb-tab>
                            <nb-tab tabTitle="Background" #bgTab>
                                <kve-cell-bg-editor
                                [section]="section"
                                [cellId]="cellId"
                                [selectedCell]="selectedCell"
                                tabbed=true></kve-cell-bg-editor>
                            </nb-tab>
                            <nb-tab tabTitle="Images" #imageTab disabled>
                                <kve-sample-image-directory
                                [section]="section"
                                tabbed=true
                                ></kve-sample-image-directory>
                            </nb-tab>
                            <nb-tab tabTitle="Layout" #layoutTab disabled>
                                <kve-cell-layout-editor
                                [section]="section"
                                [cellId]="cellId"
                                [cellLayoutThumbs]="cellLayoutThumbs"
                                tabbed=true
                                (selectedLayout)="onLayouSelected($event)"
                                ></kve-cell-layout-editor>
                            </nb-tab>
                            <nb-tab tabTitle="Styles" #colourTab disabled>
                                <kve-cell-theme-editor
                                [section]="section"
                                [cellId]="cellId"
                                tabbed=true
                                >

                                </kve-cell-theme-editor>
                            </nb-tab>

                            <nb-tab tabTitle="Link">
                                <button nbButton size="small" status="primary" (click)="export()">Download</button>
                            </nb-tab>
                        </nb-tabset>
                    </ng-container>
                </ng-container>


            </div>
        </nb-card-footer>
    </div> -->



</nb-card>
<nb-card-footer>
    <kve-editor-dialog-footer></kve-editor-dialog-footer>
</nb-card-footer>
<!-- </nb-layout> -->